import md5 from 'md5';

const { Papa } = window;
Papa.SCRIPT_PATH = `${process.env.PUBLIC_URL}/papaparse.min.js`;

export const loadFile = fileToHash => new Promise((complete, error) => {
  Papa.parse(fileToHash, {
    complete,
    error,
    header: true,
  });
});

export const hashData = (data, isUpper, hashOnly) => data.filter(row => row.email).map((row) => {
  const email = isUpper ? row.email.toUpperCase() : row.email.toLowerCase();
  if (hashOnly) {
    return {
      hash: md5(email),
    };
  }
  return {
    ...row,
    hash: md5(email),
  };
});

export const createCsv = (hashedData, originalName) => {
  const fileName = `${originalName.substring(0, originalName.lastIndexOf('.'))}_hashed.csv`;
  const blob = new Blob([Papa.unparse(hashedData)], {
    type: 'application/csv;charset=utf-8;',
  });
  return new File([blob], fileName);
};
